import "./style.scss";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Loader from "../../Components/Loader";
import MainHeader from "../../Components/MainHeader";
import LangSwitcher from "../../Components/LangSwitcher";

export default function NotFoundPage() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const token = localStorage.getItem("ps10005000");

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="notfound-container">
      {token ? null : (
        <div className="notfound-header">
          <MainHeader />
        </div>
      )}
      {loading && <Loader />}

      {token ? null : (
        <div className="notfound-language-switcher">
          <LangSwitcher />
        </div>
      )}
    </div>
  );
}
